<template>
  <v-dialog scrollable v-model="config.status.active" max-width="800px">
    <v-card class="dialog">
      <v-card-title class="primary pa-0">
        <v-toolbar flat class="amber blue-grey--text text--darken-4">
          <v-toolbar-title class="headline">備考欄</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense>
              <v-textarea outline counter
                name="comment-area"
                label="備考欄"
                maxlength="250"
                :readonly="!form.authed"
                v-model="form.comment"
              />
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed v-if="isAuthed" color="secondary" @click.stop="submit" :loading="isLoading">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'authorProgsModalsComment',
  components: {
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          importing: false
        },
        datepickers: {
          date: false
        }
      },
      form: {
        valid: true,
        id: '',
        cid: '',
        clientId: '',
        authed: false,
        comment: '',
        mid: ''
      },
      store: {
        lib: {},
        imports: []
      },
      rules: {
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/update/item/meta', {
            id: this.form.id,
            cid: this.form.cid,
            type: 'comment',
            form: {
              content: this.form.comment,
              option: {
              }
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('done', {
                id: this.form.cid,
                type: 'comment',
                value: this.form.comment
              })
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    importItems: function () {
      if (this.form.import && this.store.imports.length) {
        this.$set(this.config.status, 'loading', true)
        let items = this.store.imports.filter(it => {
          return (it.type === 'file')
        })
        if (items.length) {
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.axios.post(this.$url.api + 'box/copy/' + this.form.mid, {
              items: items
            }, {
              headers: {
                'firebase-token': token
              }
            }).then(res => {
              console.log(res)
              if (res.data && res.data.success) {
                this.closeMedia()
              } else if (
                res.data &&
                res.data.data &&
                res.data.data.response &&
                res.data.data.response.body &&
                res.data.data.response.body.code
              ) {
                let code = res.data.data.response.body.code
                let err = this.$error.box.item.move[code] ? this.$error.box.item.move[code] : ''
                if (err) {
                  this.$store.dispatch('notifier/addAlert', {
                    title: 'インポート失敗',
                    message: err
                  })
                }
              }
              this.$set(this.config.status, 'loading', false)
            }).catch(err => {
              console.log(err)
              this.$set(this.config.status, 'loading', false)
            })
          })
        }
      }
    },
    open: function (val) {
      const { id, cid, clientId, authed, mid, comment } = val
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', {
        valid: true,
        id: id,
        cid: cid,
        clientId: clientId,
        authed: authed,
        comment: comment,
        mid: mid
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    openMedia: function () {
      this.$set(this.config.status, 'importing', true)
      this.$refs.filer.init({ rid: this.store.lib.media })
    },
    closeMedia: function () {
      this.$set(this.config.status, 'importing', false)
      this.$refs.filer.init({ rid: this.form.mid })
    },
    selectImports: function (items) {
      if (this.config.status.importing) {
        let selects = items ? items.filter(it => {
          return (it.id && it.type && it.type !== 'folder')
        }) : this.store.items
        this.$set(this.store, 'imports', selects)
        this.$set(this.form, 'import', !!selects.length)
      } else {
        this.$set(this.form, 'import', false)
      }
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    isAuthed () {
      return this.form.authed
    },
    isImporting () {
      return this.config.status.importing
    },
    isSetMediaId () {
      return this.store.lib.media
    },
    printFormDate () {
      return (this.form.date) ? this.$dateformat(this.form.date, 'yyyy/mm/dd', true) : ''
    }
  }
}
</script>
